<section class="nopad">
    <div class="container-fluid register">
        <div class="row text-center">
            <div class="col-md-3 register-left">
                <div class="col-md-12 nopad">
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/AICTELogo.png" alt="Logo" style="margin-left: 25px;"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/SLALogo.png" alt="Logo"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/Parakhlogo.png" alt="Logo" style="height: 47px; margin-left: -20px;"></a>
                </div>
                <div class="col-md-12 nopad leftSection">
                    <img class="IconImg" src="https://image.ibb.co/n7oTvU/logo_white.png" alt="" />
                    <h3>Welcome</h3>
                    <p>You are a few seconds away from creating your account!</p>
                    <p>Already a user?</p>
                    <a [routerLink]="['/login']" class="mt-3 registerBtn loginBtn">LOGIN</a>
                </div>
            </div>
            <div class="col-md-9 register-right">
                <form [formGroup]="registerForm" autocomplete="off" (ngSubmit)="onSubmit(registerForm.value)"
                    class="registerFormContainer">
                    <h2 class="registerHeading">Register Yourself</h2>
                    <div class="row">

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-select name="role_id" placeholder="Register as" formControlName="role_id">
                                <mat-option value="3">Expert</mat-option>
                                <mat-option value="4">Reviewer</mat-option>
                                <!-- <mat-option value="7">Head of Department</mat-option> -->
                            </mat-select>
                            <mat-error *ngIf="registerForm.controls.role_id.errors?.required">Role is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput type="text" placeholder="Name" formControlName="name"
                                (keypress)="checkChar($event)" maxlength="100">
                            <mat-error *ngIf="registerForm.controls.name.errors?.required">Name is required</mat-error>
                            <mat-error *ngIf="registerForm.controls.name.errors?.minlength">Required (greater than 3
                                characters)
                            </mat-error>
                        </mat-form-field>


                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput placeholder="Email" formControlName="email" [value]="hoi_email">
                            <mat-error *ngIf="registerForm.controls.email.errors?.required">Email is required
                            </mat-error>
                            <mat-error *ngIf="registerForm.controls.email.errors?.invalidEmail">Invalid email address
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput type="text" placeholder="Mobile" (keypress)="checkNumber($event)"
                                formControlName="mobile" maxlength="10">
                            <mat-error
                                *ngIf="registerForm.controls.mobile.errors && (registerForm.controls.mobile.touched || registerForm.controls.mobile.dirty)">
                                Please enter a valid mobile number.</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input placeholder=" Pan Number " matInput type="text" formControlName="pan_number"
                                maxlength="10">
                            <mat-error *ngIf="registerForm.controls.pan_number.errors?.required">Pan Number is required
                            </mat-error>
                            <mat-error *ngIf="registerForm.controls.pan_number.errors?.pattern">Pan Number should be in
                                the format: ABCDE1234F</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-select name="stream" (selectionChange)="onStreamSelection($event)" placeholder="Stream"
                                formControlName="stream" maxlength="100">
                                <mat-option *ngFor="let stream of streams" value={{stream.id}}>{{stream.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="registerForm.controls.stream.errors && (registerForm.controls.stream.touched || registerForm.controls.stream.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-label>Discipline</mat-label>
                            <mat-select name="department" placeholder="Discipline" formControlName="department">
                                <mat-option *ngFor="let dept of departments" [value]="dept.id">{{dept.department}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="registerForm.controls.department.errors?.required">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-select name="organisationType" (selectionChange)="onOrganisationSelect($event)"
                                placeholder="Organisation Type" formControlName="organisationType">
                                <mat-option *ngFor="let organisation of organisations" value="{{organisation.id}}">
                                    {{organisation?.organization_type}}</mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="registerForm.controls.organisationType.errors && (registerForm.controls.organisationType.touched || registerForm.controls.organisationType.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-select name="designation" placeholder="Designation" formControlName="designation"
                                (selectionChange)="onDesignationSelect($event)">
                                <mat-option *ngFor="let designation of designations" [value]="designation.id">
                                    {{designation?.designation}}</mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="registerForm.controls.designation.errors && (registerForm.controls.designation.touched || registerForm.controls.designation.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <div class="col-12 mb-2" *ngIf="retiredProfessor" style='text-align: center'>
                            <span>Please enter the details of last Served Institute</span>
                        </div>

                        <div class="col-12 mb-2" style='text-align: left' *ngIf="instituteTypeFlag == 1">
                            <button mat-raised-button color="primary" class="mat-elevation-z6 PID_btn" type="button"
                                (click)="PIDSelect()">Select Institute
                                PId</button>
                        </div>

                        <mat-form-field [floatLabel]="'never'" class="col-6" *ngIf="instituteTypeFlag != 3">
                            <mat-select name="instituteType" placeholder="Degree/Diploma"
                                formControlName="instituteType">
                                <mat-option *ngFor="let institute of institutes" [value]="institute.id">
                                    {{institute?.institute_type}}</mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="registerForm.controls.instituteType.errors && (registerForm.controls.instituteType.touched || registerForm.controls.instituteType.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6" *ngIf="instituteTypeFlag != 3">
                            <input matInput type="text" placeholder="Institute PID"
                                formControlName="institute_permanent_id" [readonly]="instituteTypeFlag == 1" maxlength="100">
                            <mat-error
                                *ngIf="registerForm.controls.institute_permanent_id.errors && (registerForm.controls.institute_permanent_id.touched || registerForm.controls.institute_permanent_id.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-label *ngIf="instituteTypeFlag != 3">Institute Name</mat-label>
                            <mat-label *ngIf="instituteTypeFlag == 3">Organization Name</mat-label>
                            <input title="{{registerForm.controls.institute_name.value}}" matInput type="text"
                                formControlName="institute_name" [readonly]="instituteTypeFlag == 1" maxlength="100">
                            <mat-error
                                *ngIf="registerForm.controls.institute_name.errors && (registerForm.controls.institute_name.touched || registerForm.controls.institute_name.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-label *ngIf="instituteTypeFlag != 3">Institute Address</mat-label>
                            <mat-label *ngIf="instituteTypeFlag == 3">Organization Address</mat-label>
                            <input title="{{registerForm.controls.institute_name.value}}" matInput type="text"
                                placeholder="Institute Address" formControlName="institute_address"
                                [readonly]="instituteTypeFlag == 1" maxlength="100">
                            <mat-error
                                *ngIf="registerForm.controls.institute_address.errors && (registerForm.controls.institute_address.touched || registerForm.controls.institute_address.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-label *ngIf="instituteTypeFlag != 3">Institute State</mat-label>
                            <mat-label *ngIf="instituteTypeFlag == 3">Organization State</mat-label>
                            <mat-select name="state" placeholder="Institute State" formControlName="state"
                                [disabled]="instituteTypeFlag == 1">
                                <mat-option *ngFor="let state of states" [value]="state.id">{{state.state}}</mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="registerForm.controls.state.errors && (registerForm.controls.state.touched || registerForm.controls.state.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6" *ngIf="instituteTypeFlag != 3">
                            <mat-select name="payScale" placeholder="Pay Scale" formControlName="pay_scale">
                                <mat-option *ngFor="let payScale of payScales" value="{{payScale.id}}">
                                    {{payScale?.pay_scale}}</mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="registerForm.controls.pay_scale.errors && (registerForm.controls.pay_scale.touched || registerForm.controls.pay_scale.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-label>Institute Type</mat-label>
                            <mat-select name="affiliation_type" formControlName="affiliation_type">
                                <mat-option value="Government">
                                    Government</mat-option>
                                <mat-option value="Private">
                                    Private</mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="registerForm.controls.affiliation_type.errors && (registerForm.controls.affiliation_type.touched || registerForm.controls.affiliation_type.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput type="number" placeholder="Total Experience(in years)"
                                (keypress)="checkNumber($event)" formControlName="experience">
                            <mat-error
                                *ngIf="registerForm.controls.experience?.hasError('required') && (registerForm.controls.experience.touched || registerForm.controls.experience.dirty)">
                                Required</mat-error>
                            <mat-error
                                *ngIf="registerForm.controls.experience?.hasError('max') || registerForm.controls.experience?.hasError('min')">
                                Experience(in years) Should be in between 8-60 years.</mat-error>
                        </mat-form-field>

                        <div class="col-6" *ngIf="instituteTypeFlag == 3"></div>
                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput
                                matTooltip="The password should contain atleast 1 Upper case, 1 lower case, 1 special symbol and 1 number."
                                [matTooltipPosition]="'left'" placeholder="Set New Password" formControlName="password"
                                type="password" (keypress)="isSpace($event)" minlength="8" maxlength="100">
                            <mat-error *ngIf="registerForm.controls.password.errors?.required">Password is required
                            </mat-error>
                            <mat-error *ngIf="registerForm.controls.password.errors?.minlength">The password must be
                                atleast 8 characters long.
                            </mat-error>
                            <mat-error class="mb-2" *ngIf="registerForm.controls.password.errors?.pattern">It must
                                contain atleast 1 lowercase, 1 uppercase, 1 number and 1 special character each.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput placeholder="Confirm Password" formControlName="confirmPassword"
                                type="password" (keypress)="isSpace($event)" maxlength="100">
                            <mat-error *ngIf="registerForm.controls.confirmPassword.errors?.required">Confirm Password
                                is required</mat-error>
                            <mat-error *ngIf="registerForm.controls.confirmPassword.hasError('mismatchedPasswords')">
                                Passwords do not match</mat-error>
                        </mat-form-field>

                        <button mat-raised-button class="mat-elevation-z6 w-100 mt-3 registerBtn"
                            type="submit">Register</button>
                    </div>
                </form>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</section>